import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ModalContent } from 'src/app/models/modal-content.model';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ModalActionButton } from '../../../enums/modal-button-action.enum';

@Component({
  selector: 'lns-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject<void>();
  display$: Observable<boolean>;
  data: any;

  @Input() modalContent!: ModalContent;

  modalActionButton = ModalActionButton;

  constructor(private modalService: ModalService) {
    this.display$ = this.modalService.watch();
  }

  ngOnInit(): void {
    this.modalService.modal$.subscribe(data => {
      this.data = data;
    });
  }

  close(): void {
    this.modalService.close();
  }

  confirm(): void {
    this.modalService.confirm();
  }

  modalAction(action: ModalActionButton): void {
    action === ModalActionButton.Confirm ? this.confirm() : this.close();
  }

  ngOnDestroy(): void {
    this.modalService.close();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
